module.exports = __webpack_public_path__ + "img/Illustration3.c588126a.png";